const scope = "betas";
export default scope;
